if (typeof window.SectionRelatedProducts === 'undefined') {
  class SectionRelatedProducts {
    constructor(sectionEl) {
      this.sectionEl = sectionEl;
      this.splideContainer = undefined;
      this.splideInstance = undefined;
      this.init();
    }

    init() {
      if (!this.sectionEl) return;
      this.fetchRecommendations().then(() => {
        this.splideContainer = this.sectionEl.querySelector('.js-related-products-splide');
        if (this.splideContainer && typeof window.Splide !== 'undefined') {
          this.enableSplide();
        }
      }).catch(() => {
        // Fail silently; section may have been removed or no recommendations
      });
    }

    async fetchRecommendations() {
      const urlBase = this.sectionEl.getAttribute('data-url');
      const productId = this.sectionEl.getAttribute('data-product-id');
      const sectionId = this.sectionEl.getAttribute('data-section-id');
      const limit = this.sectionEl.getAttribute('data-limit');
      if (!urlBase || !productId || !sectionId) return;

      const url = `${urlBase}?section_id=${encodeURIComponent(sectionId)}&product_id=${encodeURIComponent(productId)}&limit=${encodeURIComponent(limit)}`;
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) return;
      const html = await response.text();
      const parser = document.createElement('div');
      parser.innerHTML = html;

      const incoming = parser.querySelector('[data-related-section][data-section-id] .js-related-products-content');
      const target = this.sectionEl.querySelector('.js-related-products-content');
      if (incoming && target) {
        target.innerHTML = incoming.innerHTML;
      }
    }

    enableSplide() {
      if (!this.splideInstance) {
        this.splideInstance = new window.Splide(this.splideContainer, {
          type: 'slide',
          autoWidth: true,
          gap: '1rem',
          pagination: true,
          arrows: false,
          duration: 1500,
          dragMinThreshold: 5,
          flickPower: 100,
          mediaQuery: 'min',
          speed: 500,
          easing: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
          breakpoints: {
            1024: {
              destroy: true,
            },
          }
        }).mount();
      }
    }
  }
  window.SectionRelatedProducts = SectionRelatedProducts;
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-related-section]').forEach(function(sectionEl) {
    new window.SectionRelatedProducts(sectionEl);
  });
});

